import React from "react"
import PropTypes from "prop-types"
import Icon from '../app_components/Icon'
import { semantic } from '@lexody/design-tokens'

class ConnectSectionHeader extends React.Component {
  render() {
    const { icon, iconColor, iconSolid, title, subtitle, badge, iconPulse } = this.props

    return (
      <div className="connectsSectionHeader">
        <div className="connectsSectionHeader__leading">
          <span className="connectsSectionHeader__icon" aria-hidden="true">
            {iconPulse
              ? <span className="connectsPulse" />
              : <Icon name={icon} size={18} color={iconColor} solid={iconSolid} />}
          </span>
          <div className="connectsSectionHeader__text">
            <h4 className="connectsSectionHeader__title">{title}</h4>
            {subtitle && <p className="connectsSectionHeader__subtitle">{subtitle}</p>}
          </div>
        </div>
        {badge != null && (
          <span className="connectsSectionHeader__badge" aria-label={`${badge} pending`}>
            {badge}
          </span>
        )}
      </div>
    )
  }
}

ConnectSectionHeader.propTypes = {
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  iconSolid: PropTypes.bool,
  iconPulse: PropTypes.bool,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

ConnectSectionHeader.defaultProps = {
  iconColor: semantic.primary.surface.darker,
  iconSolid: true,
  iconPulse: false,
}

export default ConnectSectionHeader
